export default __webpack_public_path__ + "static/media/top-bottom.8dcf264a.png";